import React from "react";
import ScrollToTop from "../components/ScrollToTop";
import Signin from "../components/Signin";

const SigninPage = () => {
  return (
    <>
      <ScrollToTop />
      <Signin />
    </>
  );
};

export default SigninPage;
